"use client";

import dynamic from "next/dynamic";
import React from "react";

import { Lang } from "@/i18n-config";

const AdvancedRealTimeChart = dynamic(
  () =>
    import("react-ts-tradingview-widgets").then((w) => w.AdvancedRealTimeChart),
  { ssr: false }
);

type Props = {
  lang: Lang;
  symbol: string;
};

export const TradingViewAdvancedChart = React.memo<Props>(
  ({ lang, symbol }) => (
    <AdvancedRealTimeChart
      symbol={symbol}
      locale={lang === "zh" ? "zh_TW" : "en"}
      range="12M"
      autosize
      interval="D"
      timezone="Asia/Taipei"
      theme="light"
      style="1"
      enable_publishing={false}
      hide_top_toolbar={false}
      hide_legend={false}
      withdateranges={false}
      hide_side_toolbar={true}
      allow_symbol_change={false}
      save_image={true}
      popup_width="600"
      popup_height="400"
      copyrightStyles={{
        parent: { color: "#D4D4D8" },
        span: { color: "#D4D4D8" },
      }}
    />
  )
);

TradingViewAdvancedChart.displayName = "TradingViewAdvancedChart";
